






















import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class'
import * as types from '@/store/content/types'
import FilterMenu from '@/components/FilterMenu.vue'
import Content from '@/store/models/content'
import VContentBox from '@/components/VContentBox.vue'
import VBackButton from '@/components/VBackButton.vue'
import VLoader from '@/components/VLoader.vue'

@Component({ components: { FilterMenu, VBackButton, VContentBox, VLoader } })
export default class Search extends Vue {
  @Action('searchContent', { namespace: 'content' }) searchContent!: types.SearchContentAction
  @Getter('filters', { namespace: 'content' }) getFilters!: { [key: string]: string }
  @Mutation('EMPTY_FILTERS', { namespace: 'content' }) emptyFilters!: types.EmptyFilters

  private loading = false
  private content: Content[] = []
  private ua = (this as any).$ua
  private unsubscribe!: () => void;

  private created () {
    this.emptyFilters()
    this.loadContent()
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'content/TOGGLE_FILTER') {
        this.loadContent()
      }
    })
  }

  private beforeDestroy () {
    this.unsubscribe()
  }

  @Watch('$route')
  private loadContent () {
    this.loading = true
    this.ua.trackEvent('search', 'search', this.$route.params.searchText)
    this.searchContent(this.$route.params.searchText).then((response) => {
      this.content = response
    }).finally(() => {
      this.loading = false
    })
  }
}
